import { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';
import React from 'react';
import './textLink.scss';
import { getClasses } from '@/helpers/classes';

export enum Color {
  Default = 'default',
  Inherit = 'inherit',
}

type Props = PropsWithChildren<{
  to: string;
  color?: Color;
}>;

export default function TextLink({ to, color, children }: Props) {
  const classRecords = {
    'ds-text-link': true,
    [`ds-text-link--color--${color}`]: Boolean(color),
  };

  const classes = getClasses(classRecords);

  return (
    <Link className={classes} to={to}>
      {children}
    </Link>
  );
}
